import React from "react";

function Footer() {
  const currentYear = new Date().getFullYear(); // Get the current year

  return (
    <div className="bg-gray-800 text-gray-300 font-mono p-5 w-full mt-20 flex justify-center items-center">
      <div className="text-center tracking-wide text-sm xl:text-lg">
        <h1 className="xl:text-xl text-lg">
          Made with ❤️ by{" "}
          <a
            href="https://github.com/TUNKSTUN"
            className="font-bold px-2 text-cyan-400 transition ease-in-out duration-200 hover:underline hover:text-white"
            target="_blank" // Open link in a new tab
            rel="noopener noreferrer" // Prevents potential security risks
          >
            Tunkstun
          </a>{" "}
          © {currentYear} {/* Display the current year */}
        </h1>
      </div>
    </div>
  );
}

export default Footer;
